<template>
    <rkm-modal
        extraLarge
        ref="Modal"
        title="Detalhamento da transferência"
        :buttons="['cancel']"
    >

        <rkm-row class="flex-nowrap">

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Laboratório"
                    v-model="laboratorioNomeFantasia"
                    disabled
                />
            </rkm-col>

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Local de atendimento"
                    v-model="laboratorioInfraestruturaNome"
                    disabled
                />
            </rkm-col>

        </rkm-row>

        <rkm-row class="flex-nowrap">

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Unidade origem"
                    v-model="origemNomeFantasia"
                    disabled
                />
            </rkm-col>

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Local de atendimento"
                    v-model="origemInfraestrutura"
                    disabled
                />
            </rkm-col>
        </rkm-row>

        <rkm-row class="flex-nowrap">

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Unidade destino"
                    v-model="destinoNomeFantasia"
                    disabled
                />
            </rkm-col>

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Local de atendimento"
                    v-model="destinoInfraestruturaNome"
                    disabled
                />
            </rkm-col>
        </rkm-row>

        <rkm-row class="flex-nowrap">

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Tipo"
                    v-model="origemCotaTipoNome"
                    disabled
                />
            </rkm-col>

            <rkm-col class="flex-grow-1" v-if="origemCotaTipoId == enums.tipoCota.QUANTIDADE">
                <rkm-form-input
                    label="Cota"
                    v-model="destinoCotaQuantidade"
                    disabled
                />
            </rkm-col>

            <rkm-col class="flex-grow-1" v-else>
                <rkm-form-input
                    label="Cota"
                    v-model="destinoCotaValor"
                    disabled
                />
            </rkm-col>

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Período origem"
                    v-model="origemPeriodo"
                    disabled
                />
            </rkm-col>

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Período destino"
                    v-model="destinoPeriodo"
                    disabled
                />
            </rkm-col>
        </rkm-row>

        <rkm-table
            :fields="fields"
            :items="exames"
            ref="Table"
        >

            <template v-slot:custom-foot>
                <tr>
                    <td class="table-td">
                        Total
                    </td>

                    <td class="table-td">
                        {{ getCotaExame(exames) }}
                    </td>
                </tr>
            </template>
        </rkm-table>
    </rkm-modal>
</template>

<script>

// Mixins.
import { data, formats } from '@/mixins'

// Enums.
import tipoCota from '@/enums/exame-laboratorial/tipoCota'

export default {
    computed: {
        fields() {

            const fields = [
                {
                    key: 'nome',
                    label: 'Nome',
                    class: 'col-9',
                    sortable: true
                },
                {
                    key: 'transferido',
                    label: 'Transferido',
                    class: 'col-3',
                    sortable: true
                }
            ]

            return fields
        },
    },
    data: () => ({
        exames: [],
        item: null,
        origemPeriodo: null,
        destinoPeriodo: null,
        destinoNomeFantasia: null,
        destinoInfraestruturaNome: null,
        origemCotaTipoNome: null,
        origemCotaTipoId: null,
        destinoCotaQuantidade: null,
        destinoCotaValor: null,
        laboratorioNomeFantasia: null,
        laboratorioInfraestruturaNome: null,
        origemNomeFantasia: null,
        origemInfraestrutura: null,
        enums: {
            tipoCota,
        },
    }),
    methods: {
        open(item) {

            this.exames = item.exames
            this.item = item

            this.destinoNomeFantasia = item.destinoNomeFantasia
            this.destinoInfraestruturaNome = item.destinoInfraestruturaNome
            this.origemCotaTipoNome = item.origemCotaTipoNome
            this.origemCotaTipoId = item.origemCotaTipoId
            this.destinoCotaQuantidade = item.destinoCotaQuantidade ?? 0
            this.destinoCotaValor = item.destinoCotaValor ?? '0,00'
            this.origemPeriodo = item.origemInicio + ' - ' + item.origemFim
            this.destinoPeriodo = item.destinoInicio + ' - ' + item.destinoFim

            const laboratorio = this.data.form.unidades.find(u => u.id === this.laboratorioUnidadeId)
            const laboratorioInfraestrutura = laboratorio.infraestruturas.find(u => u.id === this.laboratorioInfraestruturaId)

            this.laboratorioNomeFantasia = laboratorio.nomeFantasia
            this.laboratorioInfraestruturaNome = laboratorioInfraestrutura.nome

            const unidade = this.data.form.unidades.find(u => u.id === this.unidadeId)
            const infraestrutura = unidade.infraestruturas.find(u => u.id === this.infraestruturaId)

            this.origemNomeFantasia =  unidade.nomeFantasia
            this.origemInfraestrutura = infraestrutura.nome

            this.$refs.Modal.show()
        },
        handleExit(data) {

            this.$emit('save', data)
        },
        handleSave() {

            this.$refs.Form.save()
        },
        getCotaExame(item) {

            let cotaExame = 0

            if (this.origemCotaTipoId == this.enums.tipoCota.VALOR) {

                 cotaExame = item.reduce((sum, element) => {

                    if (element.transferido) {

                        sum = sum + this.formatSumMoney(element.transferido);
                    }

                    return sum;
                },0)

                if (cotaExame) {

                    cotaExame = this.formatMoney(cotaExame, 2)

                    return this.formatMoney(cotaExame, 2)

                } else {

                    return item.destinoCotaValor
                }


            } else {

                cotaExame = item.reduce((sum, element) => {

                    if (element.transferido) {
                        sum = sum + Number(element.transferido);
                    }

                    return sum;
                },0)

                 return cotaExame
            }
        }
    },
     mixins: [data, formats],
    props: {
        data: { type: Object, required: true },
        unidadeId: { type: Number, default: null },
        infraestruturaId: { type: Number, default: null },
        laboratorioUnidadeId: { type: Number, default: null },
        laboratorioInfraestruturaId: { type: Number, default: null },
    }
}
</script>

<style scoped>
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-width {
    width: 100%;
}

</style>